import { render, staticRenderFns } from "./SetupPackageWiki.vue?vue&type=template&id=69b07d3d&scoped=true&"
import script from "./SetupPackageWiki.vue?vue&type=script&lang=js&"
export * from "./SetupPackageWiki.vue?vue&type=script&lang=js&"
import style0 from "./SetupPackageWiki.vue?vue&type=style&index=0&id=69b07d3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b07d3d",
  null
  
)

export default component.exports